import React, { useEffect } from 'react';
import { QueryObserverRefetchErrorResult, QueryObserverSuccessResult } from 'react-query';
import { IFVContainer } from '../interfaces/FVContainer.interface';
import { IFVPackageUnitPublic } from '../interfaces/FVPackageUnit.interface';
import { useHistory, useParams } from 'react-router-dom';
import Styled from '../styles/FVContents.styled';
import StyledGlobal from '../styles/public/FerramentaVideoPublic.styled';
import StyledUnit from '../styles/FVPackageUnit.styled';
import VideoPreviewFerramentaVideo from '../components/VideoPreviewFerramentaVideo';
import { bucketS3, caminhoAnexosFerramentaVideo } from 'constants/EnvironmentData';
import MenuTypePackages from '../components/MenuTypePackages';
import { formatTitleWithIndex, formatTitleWithIndexSizeFontAll, formatTitleWithPrefixIndex } from '../helpers/FormatTitleStyleHelper';
import { AccessbilityFeatureEnum } from '../helpers/AccessbilityFeatureEnum';
import Colors from 'enums/Colors';
import { MdArrowBackIos } from 'react-icons/md';
import { YellowButton } from 'components/UI/Buttons';
import Cookies from 'js-cookie';
import { Divider } from 'antd';
import { IFVPackage } from '../interfaces/FVPackage.interface';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import { IFVRole } from '../interfaces/FVRole.interface';
import { IFVContentsPublic } from '../interfaces/FVContents.interface';

interface FVContentsProps {
    // ...other props (history, location, match, etc.)...
    listFerramenta: QueryObserverRefetchErrorResult<IFVContainer, unknown> | QueryObserverSuccessResult<IFVContainer, unknown>;
    handleRedirect?: () => void;
    setMenuActive?: (menu: string | undefined) => void;
    menuActive?: string | undefined;
    roles: IFVRole[] | null;
}

const FVContents = ({ listFerramenta, handleRedirect, setMenuActive, menuActive, roles }: FVContentsProps) => {
    const history = useHistory();
    const { urlPacote, urlFerramenta, urlUnidade } = useParams<{ urlPacote: string; urlFerramenta: string; urlUnidade: string }>();
    const [fetchedData, setFetchedData] = React.useState<IFVPackageUnitPublic | null>(null);
    const [fetchedDataPackage, setFetchedDataPackage] = React.useState<IFVPackage | null>(null);

    const [idContentSelecionado, setIdContentSelecionado] = React.useState<number>(0);
    const [indexContentSelecionado, setIndexContentSelecionado] = React.useState<number>(0);

    const ref = React.useRef<HTMLDivElement>(null);

    const isMax1170 = IsCustomMaxWidth(1170);
    const isMin1170 = IsCustomMaxWidth(1170);

    const isMax700 = IsCustomMaxWidth(700);

    const [hoveredIndexCard, setHoveredIndexCard] = React.useState<number | null>(null);

    const [viewAllContents, setViewAllContents] = React.useState<boolean>(false);

    const hasAccessibilityFeature = (content: IFVContentsPublic, feature: AccessbilityFeatureEnum) => {
        const accessibilityFeatures = content.accessibilityFeatures ?? (content.accessibilityFeature ? [content.accessibilityFeature] : []);
        return menuActive === 'none' ? accessibilityFeatures.length === 0 : accessibilityFeatures.includes(feature);
    };

    const handleRefDivClick = () => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const filteredContentsByRoles = (contents: IFVContentsPublic[]) => {
        if (!contents) return [];

        if (!roles || roles.length === 0) return contents || [];

        const filteredRole = contents.filter(content => {
            const contentRoleIds = content.roleIds ?? (content.roleId != null ? [content.roleId] : []);
            return roles.some(role => contentRoleIds.includes(role.id) || contentRoleIds.length === 0);
        });

        const filtered = filteredRole.filter(content =>
            listFerramenta?.data?.notAccessibility
                ? true
                : hasAccessibilityFeature(
                      content,
                      menuActive === 'audio'
                          ? AccessbilityFeatureEnum.AUDIO
                          : menuActive === 'libras'
                          ? AccessbilityFeatureEnum.LIBRAS
                          : AccessbilityFeatureEnum.NORMAL
                  )
        );

        return filtered;
    };

    const goToContents = (unidadeUrl: string) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        history.push(`/videos/${urlFerramenta}/${urlPacote}/${unidadeUrl}/conteudos`);
    };

    const goToBack = () => {
        if (fetchedDataPackage?.notUnit) {
            history.replace(`/videos/${urlFerramenta}/home`);
        } else {
            history.replace(`/videos/${urlFerramenta}/${urlPacote}`);
        }
    };

    const getS3Url = () => {
        return bucketS3() + caminhoAnexosFerramentaVideo();
    };

    const goToNextContent = () => {
        if (fetchedData && fetchedData.contents) {
            const currentIndex = indexContentSelecionado;
            if (currentIndex !== -1 && currentIndex < fetchedData.contents.length - 1) {
                const nextContent = filteredContentsByRoles(fetchedData.contents)[currentIndex + 1];
                setIdContentSelecionado(nextContent.codigo);
                setIndexContentSelecionado(currentIndex + 1);

                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    };

    const goToBackContent = () => {
        if (fetchedData && fetchedData.contents) {
            const currentIndex = indexContentSelecionado;
            if (currentIndex > 0) {
                const previousContent = filteredContentsByRoles(fetchedData.contents)[currentIndex - 1];
                setIdContentSelecionado(previousContent.codigo);
                setIndexContentSelecionado(currentIndex - 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    };

    useEffect(() => {
        setIdContentSelecionado(-1);
        setIndexContentSelecionado(0);
        setViewAllContents(false);

        if (menuActive && fetchedData && fetchedData.contents && fetchedData.contents.length > 0) {
            const contentFiltered = filteredContentsByRoles(fetchedData.contents);

            if (contentFiltered.length > 0) {
                setIdContentSelecionado(contentFiltered[0].codigo);
            } else {
                setIdContentSelecionado(-1);
            }
        }
    }, [menuActive, Cookies.get('menuTypePackage')]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if (listFerramenta.data && listFerramenta.data.pacotes) {
            const pacote = listFerramenta?.data?.pacotes.find(p => p.url === urlPacote);
            if (pacote && pacote.packageUnits) {
                const unidade = pacote.packageUnits.find(u => u.url === urlUnidade) as IFVPackageUnitPublic;

                if (roles && roles.length > 0 && unidade && unidade.contents) {
                    const unidades = unidade.contents.filter(content => {
                        const contentRoleIds = content.roleIds ?? (content.roleId != null ? [content.roleId] : []);
                        return roles.some(role => contentRoleIds.includes(role.id) || contentRoleIds.length === 0);
                    });

                    unidade.contents = unidades;
                }

                setFetchedData(unidade || null);

                if (unidade && unidade.contents && unidade.contents.length > 0) {
                    const contentFiltered = filteredContentsByRoles(unidade.contents);

                    if (contentFiltered.length > 0) {
                        setIdContentSelecionado(contentFiltered[0].codigo);
                    } else {
                        setIdContentSelecionado(-1);
                    }
                }

                setFetchedDataPackage(pacote);
            }
        }
    }, [listFerramenta.data, urlPacote, urlUnidade]);

    return (
        <StyledGlobal.Global.Content style={{ paddingTop: '36px', flexDirection: 'column', gap: '32px' }}>
            <Styled.Row style={{ alignItems: 'center', flexWrap: 'wrap', gap: '16px', marginTop: '10px' }}>
                <StyledGlobal.Global.ButtonBack
                    style={{ maxWidth: isMax700 ? '100%' : 'fit-content', width: isMax700 ? '100%' : 'auto' }}
                    onClick={goToBack}
                    aria-label="Voltar para a página inicial da ferramenta de vídeos"
                >
                    <span style={{ color: Colors.Yellow }}>
                        <MdArrowBackIos /> Selecionar
                    </span>{' '}
                    outros {fetchedDataPackage?.nomenclature?.toString().toLowerCase() || 'livros'}
                </StyledGlobal.Global.ButtonBack>
                {fetchedDataPackage && fetchedDataPackage.packageUnits && fetchedDataPackage.packageUnits.length > 1 && (
                    <YellowButton
                        style={{
                            height: '67px',
                            minHeight: '67px',
                            maxWidth: isMax700 ? '100%' : 'fit-content',
                            textTransform: 'uppercase',
                            fontSize: '20px',
                            borderRadius: '8px',
                            order: 0,
                        }}
                        onClick={handleRefDivClick}
                        aria-label="Scroll para escolher outras unidades"
                    >
                        Escolher {fetchedData?.nomenclature?.toString().toUpperCase()}
                    </YellowButton>
                )}
            </Styled.Row>
            <Styled.Container>
                <MenuTypePackages handleUpdateMenu={setMenuActive} hidden={listFerramenta?.data?.notAccessibility ?? false} />

                <Styled.Content gap="16px" style={{ paddingBottom: '22px' }}>
                    <Styled.Title>
                        {' '}
                        <span dangerouslySetInnerHTML={{ __html: formatTitleWithPrefixIndex(fetchedData?.title ?? '', 0) }}></span>
                    </Styled.Title>
                    {filteredContentsByRoles(fetchedData?.contents ?? [])?.length === 0 && (
                        <Styled.Video.Container style={{ color: Colors.White }}>Nenhum vídeo disponível</Styled.Video.Container>
                    )}
                    {filteredContentsByRoles(fetchedData?.contents ?? []) &&
                        filteredContentsByRoles(fetchedData?.contents ?? [])
                            .sort((a, b) => a.ordem - b.ordem)
                            .findIndex(content => content.codigo === idContentSelecionado) !== -1 &&
                        filteredContentsByRoles(fetchedData?.contents ?? [])
                            .filter(
                                content =>
                                    content.codigo === idContentSelecionado &&
                                    (listFerramenta?.data?.notAccessibility
                                        ? true
                                        : hasAccessibilityFeature(
                                              content,
                                              menuActive === 'audio'
                                                  ? AccessbilityFeatureEnum.AUDIO
                                                  : menuActive === 'libras'
                                                  ? AccessbilityFeatureEnum.LIBRAS
                                                  : AccessbilityFeatureEnum.NORMAL
                                          ))
                            )
                            .map((content, index) => {
                                if (!content.filePathVideo) {
                                    return (
                                        <div key={content.codigo} style={{ position: 'relative' }}>
                                            <Styled.Video.Container img={getS3Url() + content.filePathCapa} />
                                            <span
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                    position: 'absolute',
                                                    bottom: '40%',
                                                    left: '32%',
                                                    fontSize: '28px',
                                                    color: Colors.White,
                                                    zIndex: 2,
                                                }}
                                            >
                                                Nenhum vídeo disponível
                                            </span>
                                        </div>
                                    );
                                }

                                return (
                                    <div
                                        style={{ display: 'flex', flexDirection: 'column', gap: '22px', padding: isMax1170 ? '22px' : '0px' }}
                                        key={content.codigo}
                                    >
                                        <VideoPreviewFerramentaVideo
                                            videoUrl={(getS3Url() + content.filePathVideo) as string}
                                            capaUrl={(getS3Url() + content.filePathCapa) as string}
                                            titleVideo={formatTitleWithIndex(content.title as string, index)}
                                            isThumbnail={false}
                                            numberIndex={index}
                                            active={idContentSelecionado === content.codigo}
                                        />
                                        <Styled.TitleVideo
                                            dangerouslySetInnerHTML={{
                                                __html: formatTitleWithIndex(content?.title as string, indexContentSelecionado),
                                            }}
                                        />
                                        <Styled.DescriptionVideo dangerouslySetInnerHTML={{ __html: content?.description as string }} />
                                        {fetchedData && fetchedData.contents && fetchedData.contents.length > 1 && (
                                            <Styled.Row style={{ flexWrap: 'wrap' }}>
                                                {filteredContentsByRoles(fetchedData?.contents ?? []) &&
                                                    filteredContentsByRoles(fetchedData?.contents ?? []).sort((a, b) => a.ordem - b.ordem)
                                                        .length > 0 &&
                                                    indexContentSelecionado > 0 && (
                                                        <YellowButton
                                                            style={{
                                                                height: '67px',
                                                                minHeight: '67px',
                                                                maxWidth: 'fit-content',
                                                                textTransform: 'uppercase',
                                                                borderRadius: '8px',
                                                                fontSize: '20px',
                                                            }}
                                                            onClick={goToBackContent}
                                                            aria-label="Ir para a aula anterior"
                                                        >
                                                            Aula Anterior
                                                        </YellowButton>
                                                    )}
                                                {filteredContentsByRoles(fetchedData?.contents ?? []).filter(content =>
                                                    listFerramenta?.data?.notAccessibility
                                                        ? true
                                                        : hasAccessibilityFeature(
                                                              content,
                                                              menuActive === 'audio'
                                                                  ? AccessbilityFeatureEnum.AUDIO
                                                                  : menuActive === 'libras'
                                                                  ? AccessbilityFeatureEnum.LIBRAS
                                                                  : AccessbilityFeatureEnum.NORMAL
                                                          )
                                                ).length -
                                                    1 >
                                                    indexContentSelecionado && (
                                                    <YellowButton
                                                        style={{
                                                            height: '67px',
                                                            minHeight: '67px',
                                                            maxWidth: 'fit-content',
                                                            textTransform: 'uppercase',
                                                            borderRadius: '8px',
                                                            fontSize: '20px',
                                                            backgroundColor: 'transparent',
                                                            border: '2px solid white',
                                                            color: 'white',
                                                        }}
                                                        onClick={goToNextContent}
                                                        aria-label="Ir para a próxima aula"
                                                    >
                                                        Próxima Aula
                                                    </YellowButton>
                                                )}
                                            </Styled.Row>
                                        )}
                                    </div>
                                );
                            })}
                    <Styled.Content gap="16px" style={{ display: isMin1170 ? 'flex' : 'none' }}>
                        <div style={{ marginTop: '80px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            {filteredContentsByRoles(fetchedData?.contents ?? []) &&
                                filteredContentsByRoles(fetchedData?.contents ?? [])
                                    .sort((a, b) => a.ordem - b.ordem)
                                    .filter(content =>
                                        listFerramenta?.data?.notAccessibility
                                            ? true
                                            : hasAccessibilityFeature(
                                                  content,
                                                  menuActive === 'audio'
                                                      ? AccessbilityFeatureEnum.AUDIO
                                                      : menuActive === 'libras'
                                                      ? AccessbilityFeatureEnum.LIBRAS
                                                      : AccessbilityFeatureEnum.NORMAL
                                              )
                                    )
                                    .map((content, index) => {
                                        if (viewAllContents || (index < indexContentSelecionado + 4 && index >= indexContentSelecionado)) {
                                            return (
                                                <VideoPreviewFerramentaVideo
                                                    key={content.codigo}
                                                    videoUrl={content.filePathVideo ? ((getS3Url() + content.filePathVideo) as string) : ''}
                                                    capaUrl={(getS3Url() + content.filePathCapa) as string}
                                                    titleVideo={formatTitleWithIndex(content?.title as string, index)}
                                                    isThumbnail={true}
                                                    numberIndex={index}
                                                    active={idContentSelecionado === content.codigo}
                                                    handleActive={() => {
                                                        setIdContentSelecionado(content.codigo);
                                                        setIndexContentSelecionado(index);
                                                    }}
                                                    isAdmin={false}
                                                />
                                            );
                                        }
                                    })}

                            {filteredContentsByRoles(fetchedData?.contents ?? []) &&
                                !viewAllContents &&
                                filteredContentsByRoles(fetchedData?.contents ?? [])
                                    .sort((a, b) => a.ordem - b.ordem)
                                    .filter(content =>
                                        listFerramenta?.data?.notAccessibility
                                            ? true
                                            : hasAccessibilityFeature(
                                                  content,
                                                  menuActive === 'audio'
                                                      ? AccessbilityFeatureEnum.AUDIO
                                                      : menuActive === 'libras'
                                                      ? AccessbilityFeatureEnum.LIBRAS
                                                      : AccessbilityFeatureEnum.NORMAL
                                              )
                                    ).length > 4 && (
                                    <div>
                                        <Divider style={{ backgroundColor: 'white' }} />
                                        <YellowButton
                                            style={{
                                                height: '67px',
                                                minHeight: '67px',
                                                maxWidth: 'fit-content',
                                                textTransform: 'uppercase',
                                                borderRadius: '8px',
                                                fontSize: '20px',
                                            }}
                                            onClick={() => setViewAllContents(true)}
                                            aria-label="Exibir todos os vídeos"
                                        >
                                            Exibir todos os vídeos
                                        </YellowButton>
                                    </div>
                                )}
                        </div>
                    </Styled.Content>
                    <Divider style={{ backgroundColor: 'white' }} />
                    {fetchedDataPackage?.packageUnits && fetchedDataPackage.packageUnits.length > 1 && (
                        <>
                            <Styled.Title>
                                SELECIONE
                                <span style={{ color: Colors.Yellow }}>UMA {fetchedData?.nomenclature?.toString().toUpperCase()}</span>
                            </Styled.Title>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }} ref={ref}>
                                {fetchedDataPackage &&
                                    fetchedDataPackage.packageUnits &&
                                    fetchedDataPackage.packageUnits
                                        ?.sort((a, b) => a.ordem - b.ordem)
                                        .map((unidade, index) => {
                                            return (
                                                <React.Fragment key={unidade.id}>
                                                    <div>
                                                        <StyledUnit.CardUnit.Container
                                                            onMouseEnter={() => setHoveredIndexCard(index)}
                                                            onMouseLeave={() => setHoveredIndexCard(null)}
                                                            onClick={() => goToContents(unidade.url)}
                                                        >
                                                            <StyledUnit.CardUnit.Content
                                                                backcolor={hoveredIndexCard === index ? Colors.Yellow : Colors.White}
                                                            >
                                                                <h2>{fetchedData?.nomenclature?.toString().toUpperCase()}</h2>
                                                                <h1>{index + 1}</h1>
                                                            </StyledUnit.CardUnit.Content>
                                                            <StyledUnit.CardUnit.Content img={getS3Url() + fetchedDataPackage?.capaFilepath} />
                                                        </StyledUnit.CardUnit.Container>

                                                        {!unidade?.description && (
                                                            <StyledUnit.CardUnit.Description
                                                                hovered={hoveredIndexCard === index}
                                                                key={unidade.id}
                                                            >
                                                                <h1
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: formatTitleWithIndexSizeFontAll(unidade.title, index),
                                                                    }}
                                                                />
                                                            </StyledUnit.CardUnit.Description>
                                                        )}

                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                paddingRight: '22px',
                                                                marginTop: '16px',
                                                            }}
                                                        >
                                                            <YellowButton
                                                                onMouseEnter={() => setHoveredIndexCard(index)}
                                                                onMouseLeave={() => setHoveredIndexCard(null)}
                                                                onFocusCapture={() => setHoveredIndexCard(index)}
                                                                onClick={() => goToContents(unidade.url)}
                                                                style={{
                                                                    height: '52px',
                                                                    minHeight: '52px',
                                                                    maxWidth: 'fit-content',
                                                                    textTransform: 'uppercase',
                                                                    fontSize: '20px',
                                                                    borderRadius: '8px',
                                                                    order: 0,
                                                                }}
                                                                aria-label={`Acessar a unidade ${unidade.title}`}
                                                            >
                                                                Acessar {fetchedData?.nomenclature?.toString().toUpperCase()}
                                                            </YellowButton>
                                                        </div>
                                                    </div>
                                                    {unidade?.description?.length > 0 && (
                                                        <StyledUnit.CardUnit.Information key={unidade.id}>
                                                            <h2
                                                                dangerouslySetInnerHTML={{
                                                                    __html: formatTitleWithPrefixIndex(unidade.title, index),
                                                                }}
                                                            />
                                                            <h1>{unidade.title}</h1>
                                                            <p dangerouslySetInnerHTML={{ __html: unidade.description }} />
                                                        </StyledUnit.CardUnit.Information>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                            </div>
                        </>
                    )}
                </Styled.Content>
                <Styled.Content gap="16px" style={{ display: isMax1170 ? 'none' : 'flex' }}>
                    <div style={{ marginTop: '80px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {filteredContentsByRoles(fetchedData?.contents ?? []) &&
                            filteredContentsByRoles(fetchedData?.contents ?? [])
                                .sort((a, b) => a.ordem - b.ordem)
                                .filter(content =>
                                    listFerramenta?.data?.notAccessibility
                                        ? true
                                        : hasAccessibilityFeature(
                                              content,
                                              menuActive === 'audio'
                                                  ? AccessbilityFeatureEnum.AUDIO
                                                  : menuActive === 'libras'
                                                  ? AccessbilityFeatureEnum.LIBRAS
                                                  : AccessbilityFeatureEnum.NORMAL
                                          )
                                )
                                .map((content, index) => {
                                    if (viewAllContents || (index < indexContentSelecionado + 4 && index >= indexContentSelecionado)) {
                                        return (
                                            <VideoPreviewFerramentaVideo
                                                key={content.codigo}
                                                videoUrl={content.filePathVideo ? ((getS3Url() + content.filePathVideo) as string) : ''}
                                                capaUrl={(getS3Url() + content.filePathCapa) as string}
                                                titleVideo={formatTitleWithIndex(content?.title as string, index)}
                                                isThumbnail={true}
                                                numberIndex={index}
                                                active={idContentSelecionado === content.codigo}
                                                handleActive={() => {
                                                    setIdContentSelecionado(content.codigo);
                                                    setIndexContentSelecionado(index);
                                                }}
                                                isAdmin={false}
                                            />
                                        );
                                    }
                                })}

                        {filteredContentsByRoles(fetchedData?.contents ?? []) &&
                            !viewAllContents &&
                            filteredContentsByRoles(fetchedData?.contents ?? [])
                                .sort((a, b) => a.ordem - b.ordem)
                                .filter(content =>
                                    listFerramenta?.data?.notAccessibility
                                        ? true
                                        : hasAccessibilityFeature(
                                              content,
                                              menuActive === 'audio'
                                                  ? AccessbilityFeatureEnum.AUDIO
                                                  : menuActive === 'libras'
                                                  ? AccessbilityFeatureEnum.LIBRAS
                                                  : AccessbilityFeatureEnum.NORMAL
                                          )
                                ).length > 4 && (
                                <div>
                                    <Divider style={{ backgroundColor: 'white' }} />
                                    <YellowButton
                                        style={{
                                            height: '67px',
                                            minHeight: '67px',
                                            maxWidth: 'fit-content',
                                            textTransform: 'uppercase',
                                            borderRadius: '8px',
                                            fontSize: '20px',
                                        }}
                                        onClick={() => setViewAllContents(true)}
                                        aria-label="Exibir todos os vídeos"
                                    >
                                        Exibir todos os vídeos
                                    </YellowButton>
                                </div>
                            )}
                    </div>
                </Styled.Content>
            </Styled.Container>
            <YellowButton
                style={{
                    height: '48px',
                    minHeight: '48px',
                    maxWidth: '200px',
                    textTransform: 'uppercase',
                    borderRadius: '8px',
                    alignSelf: 'center',
                    marginTop: '50px',
                    marginBottom: '20px',
                    fontSize: '20px',
                }}
                onClick={handleRedirect}
                aria-label="Sair da ferramenta de videos"
            >
                Sair
            </YellowButton>
        </StyledGlobal.Global.Content>
    );
};

export default FVContents;
